import { Button, ButtonProps } from "@mui/material";

export const MyButton = (props: ButtonProps) => {
  return (
    <Button
      variant="contained"
      sx={{
        boxShadow: "10px -9px 21px -5px rgba(0,0,0,0.75)"
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
};
